module.exports = __webpack_public_path__ + "img/boy_010002.a41a6d65.png";